module.exports = __webpack_public_path__ + "static/media/ball_5_2.57feee47.mp3";